export const greyBaseColor = '#999';
export const greyStroke = '#d9d9d9';
export const halfTransparent = 0.5;
export const highlightColor = '#f5f5f5';
export const opaque = 1;
